import React from 'react';
import { Facebook, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8">
          {/* École Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">École de la Pizza italienne</h3>
            <p className="text-gray-300 mb-4">
              Formation d'excellence en pizza napolitaine avec Joseph Cardone, 
              maître pizzaïolo reconnu avec plus de 30 ans d'expérience.
            </p>
            <div className="flex items-center gap-2 text-yellow-400">
              <Facebook className="h-5 w-5" />
              <span className="text-sm">2.9K abonnés</span>
            </div>
          </div>

          {/* Formations */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Nos Formations</h4>
            <ul className="space-y-2 text-gray-300">
              <li><a href="#expert-napolitaine" className="hover:text-yellow-400 transition-colors">Expert Pizza Napolitaine</a></li>
              <li><a href="#formations" className="hover:text-yellow-400 transition-colors">Formation Pizzaïolo</a></li>
              <li><a href="#formations" className="hover:text-yellow-400 transition-colors">CQP Pizzaïolo</a></li>
              <li><a href="#formations" className="hover:text-yellow-400 transition-colors">Hygiène Alimentaire HACCP</a></li>
              <li><a href="#formations" className="hover:text-yellow-400 transition-colors">Création d'Entreprise</a></li>
              <li><a href="#formations" className="hover:text-yellow-400 transition-colors">Ateliers Particuliers</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <div className="space-y-3 text-gray-300">
              <div className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-yellow-400" />
                <span>06 60 47 67 40</span>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-yellow-400" />
                <a 
                  href="mailto:ecoledelapizza@gmail.com"
                  className="text-gray-300 hover:text-yellow-400 transition-colors"
                >
                  ecoledelapizza@gmail.com
                </a>
              </div>
              <div className="flex items-start gap-2">
                <MapPin className="h-4 w-4 text-yellow-400 mt-1" />
                <div>
                  <div>2720 Chemin Saint Bernard</div>
                  <div>Porte 14 bâtiment Sodimats</div>
                  <div>06220 Vallauris, France</div>
                </div>
              </div>
            </div>
          </div>

          {/* Certifications */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Certifications</h4>
            <div className="space-y-2 text-gray-300 text-sm">
              <div>N° déclaration d'activité: 93060778006</div>
              <div>Certification Qualiopi</div>
              <div>Enregistré ROFHYA</div>
              <div>Préfecture PACA</div>
            </div>
            <div className="mt-4">
              <h5 className="font-semibold mb-2">Financement</h5>
              <div className="flex flex-wrap gap-2">
                <span className="bg-blue-600 px-2 py-1 rounded text-xs">CPF</span>
                <span className="bg-green-600 px-2 py-1 rounded text-xs">Pôle Emploi</span>
                <span className="bg-purple-600 px-2 py-1 rounded text-xs">OPCO</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-gray-400 text-sm">
              © 2024 École de la Pizza Napolitaine. Tous droits réservés.
            </div>
            <div className="flex gap-6 text-sm text-gray-400">
              <a href="#mentions-legales" className="hover:text-yellow-400 transition-colors">Mentions légales</a>
              <a href="#rgpd" className="hover:text-yellow-400 transition-colors">RGPD</a>
              <a href="#cgv" className="hover:text-yellow-400 transition-colors">CGV</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;